
export interface AudioPlayer {
    play(message: any): void;
}
